import { ifBasePath } from '../config/baseConfig';
import Redux from '../redux/ReduxConnector';
import pLimit from 'p-limit';
import { chunkArray } from '../utils/chunk-utils';

export interface ApplicationEntry {
  propertyId?: string;
  contractId?: string;
  customerLastName?: string;
  customerFirstName?: string;
  customerLastNameKana?: string;
  customerFirstNameKana?: string;
  customerPhoneNumber?: string;
  customerEmail?: string;
  customerBirthDay?: string;
  hasElectricContract?: boolean;
  useGasPlanSelection?: string;
  paymentMethodSelection?: string;
  electricityBasePlanSelection?: string;
  electricityStartDate?: string;
  gasBasePlanSelection?: string;
  gasStartDate?: string;
  gasStartTimeSelection?: string;
  witnessGasStart?: string;
  witnessNameGasStart?: string;
  phoneNumberForGasStart?: string;
  serviceStopDate?: string;
  isModifiedInSameDay?: boolean;
  isCanceledInSameDay?: boolean;
  linkageId?: string;
  createdAt?: string;
  isOverServiceStopDate?: boolean;
  boCustomerNo?: string;
  viewnContractId?: string | number;
  applicationCategory?: string;
  postCode?: string;
  prefecture?: string;
  city?: string;
  afterCity?: string;
  address2?: string;
  propertyServiceCode?: string;
  sumamoru_plan?: string;
  sumamoruAdditionalServices?: string[];
}

export async function getApplicationsData(propertyIds: Array<string>): Promise<ApplicationEntry[]> {
  const user = Redux.getStore().user;
  const CHUNK_SIZE = 200;
  const CONCURRENCY = 2; // limit concurrent API calls

  const url = `${ifBasePath}application/entries`;
  const method = 'POST';
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': user.accessToken
  };
  const limit = pLimit(CONCURRENCY);
  const chunks = chunkArray(propertyIds, CHUNK_SIZE);
  const results: ApplicationEntry[] = [];
  try {
    const fetchChunk = async (chunk: string[]) => {
      const body = JSON.stringify({ propertyId: chunk });
      console.log('propertyIds Count:', chunk.length);
      try {
        const res = await fetch(url, { method, headers, body, mode: 'cors' });
        if (!res.ok) {
          console.error('Fetch failed for chunk:', chunk);
          return [];
        }
        return await res.json();
      } catch (err) {
        console.error('Fetch error for chunk:', chunk, err);
        return [];
      }
    };

    // Execute API calls with concurrency limit
    const promises = chunks.map(chunk => limit(() => fetchChunk(chunk)));
    const chunkResults = await Promise.all(promises);

    // Flatten results
    for (const items of chunkResults) {
      results.push(...items);
    }
    console.log('results:', results);
    return results;
  } catch (error) {
    console.error('getApplicationsData Error:', error);
    return [];
  }
}
